import {ModalTabCompletedBadge} from './ModalTabCompletedBadge';
import {cn} from '../../lib/utils';
import {Icon} from '../Icon/Icon';

import type {IconName} from '@/icons/icon-map';
import type {FC, ReactNode} from 'react';

interface ModalTabIconLabelBaseProps {
  text: string;
  completed?: boolean;
  /** When true, suppresses the completed badge even if completed=true */
  disabled?: boolean;
  /** Optional badge rendered next to the label text (e.g. a "Coming Soon" chip) */
  badge?: ReactNode;
}

export type ModalTabIconLabelProps = ModalTabIconLabelBaseProps &
  ({icon: IconName; illustration?: never} | {icon?: never; illustration: ReactNode});

/** Tab label for multi-step modals: an icon-box (icon or illustration) + text, or a ModalTabCompletedBadge once complete. */
export const ModalTabIconLabel: FC<ModalTabIconLabelProps> = ({
  icon,
  illustration,
  text,
  completed,
  disabled,
  badge
}) => {
  if (completed && !disabled) {
    return <ModalTabCompletedBadge label={text} />;
  }

  return (
    <span data-slot="modal-tab-icon-label" className="flex items-center gap-3">
      <div
        data-slot="icon-box"
        className={cn(
          'flex size-10 shrink-0 overflow-hidden rounded-md border border-border items-center justify-center bg-background-secondary',
          disabled && 'opacity-50'
        )}
      >
        {icon ? <Icon name={icon} width={20} height={20} /> : illustration}
      </div>
      <span data-slot="label" className="flex items-center gap-2">
        <span className={cn(disabled && 'opacity-50')}>{text}</span>
        {badge}
      </span>
    </span>
  );
};
